<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { currentUser } from '$lib/stores/auth';

  // Shown once per user per browser after the election (dismissal kept in
  // localStorage, keyed by user id).
  const key = (id: string) => `canvass.congrats2026.${id}`;
  function seen(id: string): boolean {
    try { return localStorage.getItem(key(id)) === '1'; } catch { return false; }
  }
  let dismissedId: string | null = null;
  $: user = $currentUser;
  $: open = !!user && dismissedId !== user.id && !seen(user.id);
  $: isApril = user?.username === 'april';

  function close() {
    if (!user) return;
    try { localStorage.setItem(key(user.id), '1'); } catch {}
    dismissedId = user.id;
  }
  function viewResults() { close(); push('/results'); }
</script>

{#if open}
  <button class="backdrop" on:click={close} aria-label="Close" />
  <section class="congrats" role="dialog" aria-modal="true" aria-labelledby="congrats-title">
    {#if isApril}
      <h2 id="congrats-title">Congratulations, April!</h2>
      <p>Well done on a well-run campaign. We're so proud of you.</p>
    {:else}
      <h2 id="congrats-title">Thank you!</h2>
      <p>Thank you so much for all of your support of April and all the work you've done. We couldn't have done it without you.</p>
    {/if}
    <div class="actions">
      <button class="primary" type="button" on:click={viewResults}>See the results</button>
      <button type="button" on:click={close}>Close</button>
    </div>
  </section>
{/if}

<style>
  .backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.45); border: 0; z-index: 2000; cursor: default; }
  .congrats {
    position: fixed; z-index: 2001; left: 50%; top: 50%; transform: translate(-50%, -50%);
    width: min(440px, calc(100vw - 32px)); background: var(--paper); color: var(--ink);
    padding: 28px 24px 20px; box-shadow: 0 12px 40px rgba(0,0,0,0.3); text-align: center;
    font-family: var(--font-body);
  }
  h2 { margin: 0 0 12px; font-family: var(--font-display, inherit); font-size: 1.6rem; }
  p { margin: 0 0 20px; line-height: 1.5; }
  .actions { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
  .actions button { padding: 10px 16px; font: inherit; font-weight: 600; cursor: pointer; border: 1px solid var(--ink); background: transparent; color: var(--ink); }
  .actions .primary { background: var(--leaf, var(--ink)); border-color: var(--leaf, var(--ink)); color: var(--paper); }
</style>
